import { fetchToken } from "../../../common/FetchCookie";
import { ADMIN, BASE_URL, CITY, CORE, CORE_CITY } from "../../../common/URLs";

export const fetchCityList = async (page) => {
  const url = `${BASE_URL}/${ADMIN}/${CITY}?page=${page}`; // Proxy path
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",

        Authorization: `Bearer ${token}`,
      },
    });
    //   console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const addCity = async (newCity) => {
  const url = `${BASE_URL}/${CORE}/${CORE_CITY}`; // Proxy path
  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newCity),
    });
    const data = await response.json();
    // console.log("API Data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const deleteCity = async (uuid) => {
  try {
    const token = await fetchToken();

    const response = await fetch(`${BASE_URL}/${CORE}/${CORE_CITY}/${uuid}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Error deleting : " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error deleting : " + error.message);
  }
};

export const updateCity = async (uuid, cityData) => {
  try {
    const token = await fetchToken();

    const response = await fetch(`${BASE_URL}/${CORE}/${CORE_CITY}/${uuid}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(cityData),
    });

    if (!response.ok) {
      throw new Error("Error updating : " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating : " + error.message);
  }
};
